module.exports = __webpack_public_path__ + "img/Wynwood Dorsey.bf497e5c.jpg";